import {observer} from 'mobx-react-lite'
import React from 'react'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {Filter} from './extensions-gallery'
import {ExtensionStore} from './extensions-store'
import {ExtensionDetailsMain} from './screens/details/details-main'
import {ExtensionsListMain} from './screens/list/list-main'
import {ExtensionSettingsMain} from './screens/settings/extension-settings-main'

type ExtensionsGalleryMainProps = {
  openedDetails: ExtensionStore
  openedSettings: ExtensionStore
  onOpenDetails: (ext: ExtensionStore) => void
  onOpenSettings: (ext: ExtensionStore) => void
  onCloseSettings: () => void
  onCloseDetails: () => void
  onSortingOptionsChanged: (option: OptionsItem) => void
  onClickScrollToTop: () => void
  isSearchActive: boolean
  searchResultsTitle: string
  activeFilter: Filter
  filteredList: ExtensionStore[]
  activeSortingOption: OptionsItem
}

export const ExtensionsGalleryMain = observer(
  ({
    openedDetails,
    openedSettings,
    activeFilter,
    filteredList,
    isSearchActive,
    searchResultsTitle,
    activeSortingOption,
    onOpenDetails,
    onCloseDetails,
    onOpenSettings,
    onCloseSettings,
    onSortingOptionsChanged,
    onClickScrollToTop
  }: ExtensionsGalleryMainProps) => {
    // NOTE: the order of if-statements is important here
    if (openedSettings) {
      return (
        <ExtensionSettingsMain
          openedDetails={openedDetails}
          openedSettings={openedSettings}
          onClickBack={onCloseSettings}
        />
      )
    }

    if (openedDetails) {
      return (
        <ExtensionDetailsMain
          openedDetails={openedDetails}
          onCloseDetails={onCloseDetails}
        />
      )
    }

    return (
      <ExtensionsListMain
        activeFilter={activeFilter}
        filteredList={filteredList}
        onOpenSettings={onOpenSettings}
        onOpenDetails={onOpenDetails}
        onClickScrollToTop={onClickScrollToTop}
        isSearchActive={isSearchActive}
        searchResultsTitle={searchResultsTitle}
        activeSortingOption={activeSortingOption}
        onSortingOptionsChanged={onSortingOptionsChanged}
      />
    )
  }
)
